module.exports = __webpack_public_path__ + "img/smile.775a0a6d.svg";